import React, { ReactElement } from "react";

interface StatCardProps {
  label: string;
  value: string;
  icon: React.ReactNode;
  isLoading: boolean;
}

function StatCardLoading() {
  return (
    <div className="border rounded-lg p-4 h-16 flex justify-between text-right">
      <div className="animate-pulse h-8 w-8 bg-gray-100 rounded-lg" />
      <div className="space-y-2">
        <div className="h-2 w-32 animate-pulse bg-gray-200" />
        <div className="text-right w-full flex justify-end">
          <div className="h-4 w-16 animate-pulse bg-gray-200 self-end" />
        </div>
      </div>
    </div>
  );
}

export default function StatCard(props: StatCardProps): ReactElement {
  const { label, value, icon, isLoading } = props;

  if (isLoading) {
    return <StatCardLoading />;
  }

  return (
    <div className="border rounded-lg p-4 flex justify-between text-right">
      <div>{icon}</div>
      <div className="space-y-2">
        <p className="text-xs">{label}</p>
        <p className="text-xl font-semibold">{value}</p>
      </div>
    </div>
  );
}
